import { type InstallationPlan, installationPlanSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const responseSchema = z.object({
  installationPlans: z.array(installationPlanSchema),
});

interface Params {
  projectId: string;
  noRetry?: boolean;
}

export function useInstallationPlans({ projectId, noRetry = false }: Params) {
  const url = `/projects/${projectId}/documentation/installation-plans`;

  const { data, error, isLoading, refetch, isFetching } = useQuery<{
    installationPlans: InstallationPlan[];
  }>({
    queryKey: queryKeys.getInstallationPlans(projectId),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: !!projectId,
    retry: !noRetry,
  });

  return {
    installationPlans: data?.installationPlans || [],
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
